module.exports = __webpack_public_path__ + "81c6ae607703c1e3719983c1bc50af1e.svg";